import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IActiveChat } from 'app/shared/models/chat.model';
import { ChatService } from 'app/shared/services/chat.service';
@Component({
  selector: 'app-chat-panel',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './chat-panel.component.html',
  styleUrl: './chat-panel.component.scss'
})
export class ChatPanelComponent {
  @Input() isOpen!: boolean;
  @Output() close = new EventEmitter<boolean>();

  constructor(public chatService: ChatService, private router: Router) { }

  closePanel() {
    this.close.emit(true);
  }

  navigateToCase(chat: IActiveChat) {
    this.router.navigate([`/case-form/${chat.chatRoomName}`]);
    this.closePanel();
  }
}
